import PaymentPage from './paymentPage';

export default PaymentPage;